// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Desktop Layout Container */
.desktop-layout {
  display: none;
  height: 100vh;
  width: 100%;
  flex-direction: row;
  overflow: hidden;
}

@media (min-width: 768px) {
  .desktop-layout {
    display: flex;
  }
}

/* Mobile Layout Container */
.mobile-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

@media (min-width: 768px) {
  .mobile-layout {
    display: none;
  }
}

/* Main Content Area */
.main-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  background-color: var(--bg-main);
  position: relative;
}

/* Mobile Header */
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  height: var(--mobile-header-height);
  background-color: var(--bg-main);
  position: sticky;
  top: 0;
  z-index: 20;
}

/* Mobile Note Overlay */
.mobile-note-overlay {
  position: fixed;
  inset: 0;
  background-color: var(--bg-main);
  z-index: 40;
  display: none;
  flex-direction: column;
  overflow-y: auto;
}

.mobile-note-overlay.active {
  display: flex;
}

/* Modal Backdrop */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-backdrop.active {
  display: flex;
}

/* Modal Container */
.modal-container {
  background-color: var(--bg-card);
  border-radius: 1rem;
  width: 100%;
  max-width: 32rem;
  max-height: 90vh;
  overflow: auto;
  box-shadow: var(--shadow-lg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/layout.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B","sourcesContent":["/* Desktop Layout Container */\n.desktop-layout {\n  display: none;\n  height: 100vh;\n  width: 100%;\n  flex-direction: row;\n  overflow: hidden;\n}\n\n@media (min-width: 768px) {\n  .desktop-layout {\n    display: flex;\n  }\n}\n\n/* Mobile Layout Container */\n.mobile-layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .mobile-layout {\n    display: none;\n  }\n}\n\n/* Main Content Area */\n.main-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  height: 100%;\n  background-color: var(--bg-main);\n  position: relative;\n}\n\n/* Mobile Header */\n.mobile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  height: var(--mobile-header-height);\n  background-color: var(--bg-main);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n/* Mobile Note Overlay */\n.mobile-note-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: var(--bg-main);\n  z-index: 40;\n  display: none;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.mobile-note-overlay.active {\n  display: flex;\n}\n\n/* Modal Backdrop */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 50;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.modal-backdrop.active {\n  display: flex;\n}\n\n/* Modal Container */\n.modal-container {\n  background-color: var(--bg-card);\n  border-radius: 1rem;\n  width: 100%;\n  max-width: 32rem;\n  max-height: 90vh;\n  overflow: auto;\n  box-shadow: var(--shadow-lg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
